import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";

document.querySelectorAll(".js-markets").forEach((el) => {
	initOnScrollAnimation(el);
});
